<template>
  <div class="w100">
    <div class="header_wrapper">
      <div class="header_box">
        <div class="header_content_in">
          <div class="logo_box">
            <img src="../assets/img/logo_hr.png" alt="logo" class="logo" @click="changeActived(1);routeGo('index')"/>
            <!-- <img src="../assets/img/dingding1.png" alt class="logo1" @click="goDing" /> -->
            <img src="../assets/img/qiwei.png" alt class="logo1"  @click="goQiwei"/>
          </div>
          <div class="flex align-item-center" v-if="activeIndex != 110 || activeIndex != 111">
            <el-menu
              class="header_menu"
              :default-active="activeIndex"
              mode="horizontal"
              text-color="#1f2329"
              active-text-color="#007bff"
            >         
              <el-menu-item index="1" @click="changeActived(1);routeGo('index')">满分HR</el-menu-item>
              <!-- <el-menu-item index="2" @click="changeActived(2);routeGo('')">产品功能</el-menu-item> -->
              <!-- <el-submenu index="2">
                <template slot="title">产品功能</template>
                <el-menu-item index="2-1" @click="changeActived('2-1');routeGo('background')">智能背调</el-menu-item>
                <el-menu-item index="2-2" @click="changeActived('2-2');routeGo('jobs')">智能招聘</el-menu-item>
              </el-submenu> -->
               <!-- <el-submenu index="2">
                <template slot="title">产品介绍</template>
                <el-menu-item index="2-1" @click="changeActived('2-1');routeGo('dingding')">易招聘X钉钉</el-menu-item>
                <el-menu-item index="2-2" @click="changeActived('2-2');routeGo('qiwei')">易招聘X企业微信</el-menu-item>
              </el-submenu>
              <el-menu-item index="10" @click="changeActived(10);routeGo('chromeNew')">小易插件</el-menu-item> -->
              <el-menu-item index="11" @click="changeActived(11);routeGo('customizedService')">定制服务</el-menu-item>   
              <!-- <el-menu-item index="3" @click="changeActived(3);routeGo('price')">价格</el-menu-item> -->
              <el-menu-item index="4" @click="changeActived(4);routeGo('cases')">客户案例</el-menu-item>
              <el-submenu index="12">
                <template slot="title">关于我们</template>
                <el-menu-item index="12-1" @click="changeActived('12-1');routeGo('whoAreWe')">我们是谁</el-menu-item>
                <el-menu-item index="12-2" @click="changeActived('12-2');routeGo('channelsSupport')">渠道合作</el-menu-item>
                <!-- <el-menu-item index="12-3" @click="changeActived('12-3');routeGo('downloadCenter')">下载中心</el-menu-item> -->
              </el-submenu>
              <!-- <el-menu-item index="13" @click="changeActived(11);routeGo('problem')">招聘ATS新闻</el-menu-item> -->
              
              <!-- <el-menu-item index="5" @click="changeActived(5);routeGo('download')">下载中心</el-menu-item> -->
              <!-- <el-menu-item index="6" @click="changeActived(6);routeGo('service')">客户服务</el-menu-item> -->
              <!-- <el-menu-item index="7" @click="changeActived(7);routeGo('about')">关于我们</el-menu-item> -->
              <!-- <el-menu-item index="8" @click="changeActived(8);routeGo('')">视频介绍</el-menu-item> -->
              <!-- <el-menu-item index="8" @click="changeActived(8);routeGo('')">视频介绍</el-menu-item> -->
              <!-- <el-submenu index="9">
                <template slot="title">学习中心</template>
                <el-menu-item index="9-1" @click="changeActived('9-1');routeGo('learn')">帮助文档</el-menu-item>
                <el-menu-item index="9-2" @click="changeActived('9-2');routeGo('problem')">常见问题</el-menu-item>
                <el-menu-item index="9-3" @click="changeActived('9-3');routeGo('chrome')">视频介绍</el-menu-item>
              </el-submenu> -->
              <!-- <el-menu-item class="menu_login" index="13" @click="goLogin">登录</el-menu-item> -->
            </el-menu>
            <!-- <button style="background-color: dodgerblue;width:80px;height: 40px;color: aliceblue;border-color: dodgerblue;border-radius: 4px;border: 0cap;" @click="goLogin">登录</button> -->
            <!-- <img src="../assets/img/login-mf.jpg" alt  @click="goLogin"/> -->
          </div>
          <!-- <div class="header_title" v-if="activeIndex == 111">邮箱绑定教程</div>
          <div class="header_title" v-if="activeIndex == 110">发件邮箱配置说明</div> -->
        </div>
      </div>
    </div>
    <div>
      <div class="content">
        <router-view />
      </div>
    </div>
    <page_footer class="index_footer"></page_footer>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import page_footer from "./footer.vue";
export default {
  components: { page_footer },
  data: function() {
    return {
    };
  },
  mounted: function() {
  },
  computed: {
    activeIndex: function() {
      return this.$store.state.first_nav.toString();
    }
  },
  methods: {
    ...mapActions({
      changeActived: "first_nav_change",
    }),
    routeGo: function(to) {
      if (to) {
        this.$router.push({ name: to });
      } else {
        // this.$message.warning("正在开发");
      }
    },
    goDing(){
      // let url = 'https://appcenter.dingtalk.com/detail.html?goodsCode=DD_GOODS-101001048911&sig=dabf78575b0f7b9bae7fca43be1efed0'
      let url = ''
      window.open(url,'_blank')
    },
    goQiwei(){
      let url = 'https://open.work.weixin.qq.com/appStore/app?appId=MTk3MDMyNjIzOTk5MzM1MF8xMDYzNjE2XzE%3D&source=search&delivery_from=search'
      window.open(url,'_blank')
    },
    goLogin(){
      let url = 'https://web.manfenokr.com/okr/okr-manager.html#/login';
      window.open(url,'_blank')
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/backendMod.vue